import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppConfiguration } from "read-appsettings-json";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    return (
      <React.Fragment>
        <span>
          v{AppConfiguration.Setting().AppVersion}
        </span>
        &ensp; 
        <span><a href={window.location.origin} target="_blank"> {AppConfiguration.Setting().ShortAppName} </a> &copy; {new Date().getFullYear()} {window.location.host}</span>
        <span className="ml-auto">Powered by <a href="http://www.apexintegra.com" target="_blank">Apex Integra</a></span>
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
